<template>
  <div class="ml-auto mb-1 flex gap-1" aria-live="polite" :aria-atomic="true">
    <p class="text-sm text-grey-200 whitespace-nowrap">
      <span v-show="loading" class="animate-pulse mr-1">Sauvegarde en cours</span>
      <span v-show="!loading">Sauvegardé</span>
    </p>
    <OhVueIcon
      :name="loading ? savingIcon : savedIcon"
      :scale="loading ? 1 : 1.3"
      :class="{
        'text-success-425': !loading,
        'animate-ping text-warning-425': loading,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import { useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { RiCloudLine, RiUploadCloud2Line } from "oh-vue-icons/icons";

interface Props {
  loading: boolean;
}
withDefaults(defineProps<Props>(), { loading: false });

const [savedIcon, savingIcon] = useIcons(RiCloudLine, RiUploadCloud2Line);
</script>
